import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, Paper, Stack, Typography } from "@mui/material";

// «Nueva automatización»: elige qué tipo crear. Recibe solo los tipos que el usuario puede crear.
const AutomationTypePicker = ({ open, types = [], onClose, onSelect }) => (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>¿Qué quieres automatizar?</DialogTitle>
        <DialogContent>
            <Stack spacing={1.25} sx={{ pb: 1 }}>
                {types.map((type) => {
                    const Icon = type.icon;
                    return (
                        <Paper
                            key={`automation-type-${type.key}`}
                            variant="outlined"
                            role="button"
                            tabIndex={0}
                            onClick={() => onSelect(type)}
                            onKeyDown={(event) => { if (event.key === "Enter") onSelect(type); }}
                            sx={{
                                p: 1.75,
                                borderRadius: 3,
                                cursor: "pointer",
                                transition: "border-color 160ms ease, box-shadow 160ms ease",
                                "&:hover, &:focus-visible": {
                                    borderColor: "primary.main",
                                    boxShadow: "0 12px 30px rgba(103, 58, 183, 0.12)",
                                    outline: "none",
                                },
                            }}>
                            <Stack direction="row" spacing={1.5} alignItems="center">
                                <Box
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 2.5,
                                        display: "grid",
                                        placeItems: "center",
                                        color: "primary.main",
                                        bgcolor: "rgba(103, 58, 183, 0.08)",
                                        flex: "0 0 auto",
                                    }}>
                                    {Icon && <Icon />}
                                </Box>
                                <Box sx={{ minWidth: 0 }}>
                                    <Typography variant="h6" sx={{ lineHeight: 1.2 }}>{type.pickerTitle}</Typography>
                                    <Typography variant="body2" color="text.secondary">{type.pickerDescription}</Typography>
                                </Box>
                            </Stack>
                        </Paper>
                    );
                })}
            </Stack>
        </DialogContent>
    </Dialog>
);

export default AutomationTypePicker;
